/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import React from "react"
import LayoutContainer from "./layoutContainer"

const LayoutSection = ({ 
  children, //Le contenu encadré par le composant
  id, //L'id pour le css
  full, //Si mentionné la section ne comporte pas de Div container
  lineStep, //La position de la section dans la page
  type, //classe CSS 
  reference,// Référence pour la détection en cas de scroll 
  colorBckgd, //La couleur de background de la balise  
  extraclass, //Les classes CSS supplémentaires
  border, //Bordure 
  noPaddingBottom, //Pas de padding bottom 
 }) => {

  return (
    <section
      id={id}
      ref={reference}
      className={`section h-full flex justify-center items-center ${type ? type : ''} ${colorBckgd ? colorBckgd : ''} overflow-hidden relative div${lineStep} ${extraclass ? extraclass : ''} py-8 md:py-0 md:min-h-screen`}>
      {
        full 
        ?  children  
        : <LayoutContainer border={border} noPaddingBottom={noPaddingBottom}> {children} </LayoutContainer>
      }
    </section >
  )
}
export default LayoutSection
